import React from "react";

import {
    Label,
} from "reactstrap";

import Request from '../../common/Request';
import DialogBase from '../Base/DialogBase';
import InputText from '../FormParts/InputText'
import FormatCode from '../../common/FormatCode';
import format_url from '../../variables/format_url';
import GoogleDrive from "../../common/GoogleDrive"
import { GetMessage, getErrorCodes } from "../../variables/message";
import ImageControl from '../FormParts/ImageControl'
import StaticMap from '../../common/StaticMap'

import custom_report from "../../variables/custom_report"

const moment = require("moment");

class RegistDialog extends DialogBase {
    constructor(props) {
        super(props);

        Object.assign(this.state, {
            title: '提出区画図登録・更新',
            plotting_number_flag: this.props.plotting_number_flag ? this.props.plotting_number_flag : false,
            data: {
                values: this.props.data,
                errors: {},
                requiredData: {}
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            let errors = {...(this.props.data.values.quote_plotting_picture_url ? {} : { quote_plotting_picture_url: [GetMessage(2024)] })};
            let requiredData = {quote_plotting_picture_url: [GetMessage(2024)]};
            // if(this.state.plotting_number_flag == true){
            //     errors["quote_plotting_number"] = this.props.data.errors.quote_plotting_number || (this.props.data.values.quote_plotting_number ? undefined : [GetMessage(2024)]);
            //     requiredData["quote_plotting_number"] = [GetMessage(2024)];
            // }            

            this.setState({
                data: {
                    ...this.props.data,
                    values: this.props.data.values,
                    errors: errors,
                    requiredData: requiredData,
                }
            })
        }
    }
    validate() {
        let message = getErrorCodes(this.state.data.errors)

        if (message.length > 0) {
            this.props.alertModal.current.showErrorModal({ messageNo: message });
            return false;
        }
        return true;
    }
    
    async handleClickPositive() {
        if (!this.validate()) {
            return;
        }

        const {
            id,
            estimate_natural_id,
            customer_branch_natural_id,
            customer_user_natural_id,
            project_natural_id,
            request_natural_id,
            subcontract_customer_branch_natural_id,
            subcontract_customer_user_natural_id,

            survey_capacity_flag_car,
            survey_capacity_flag_light_truck,
            quote_plotting_number,
            quote_capacity_qty,
            quote_available_start_date,
            quote_available_end_date,
            survey_parking_picture_url,
            survey_route_picture_url,
            quote_plotting_picture_url,
            survey_parking_address_contract,
            survey_site_distance_meter,
            survey_site_distance_minute,
            latest_pdf_plotting_url: original_latest_pdf_plotting_url,
            user_branch_natural_id,
            parking_latitude,
            parking_longitude,
            project_latitude,
            project_longitude,
            want_guide_type,
            want_guide_type_subcontract,
            survey_route_zoom_qr_url,
            survey_route_zoom_picture_url,
        } = this.state.data.values
        Request.setProgress(10)

        try {
            const estimateCommonParams = await Request.getEstimateCommon({
                customer_branch_natural_id,
                customer_user_natural_id,
                project_natural_id,
                request_natural_id,
                subcontract_customer_branch_natural_id,
                subcontract_customer_user_natural_id,
                estimateObject: this.state.data.values,
                user_branch_natural_id
            })

            Request.setProgress(20)
            // create static map
            let routeData;
            // try{
            //     console.log(this.state.data.values);
            //     await StaticMap.googleMapScript();
            //     routeData = await StaticMap.createStaticGoogleMap(
            //         {
            //             latitude: project_latitude,
            //             longitude: project_longitude
            //         },
            //         [{
            //             latitude: parking_latitude,
            //             longitude: parking_longitude
            //         }],
            //         [],
            //         true
            //     )
    
            // }catch(err){
            //     console.log(err);
            // }
            
            // const uploadResult = await StaticMap.uploadCanvas(routeData[0].canvas, 'q_route_picture')

            Request.setProgress(30)
            // const zoomedUploadResult = await StaticMap.uploadZoomedRoute(
            //     routeData[0],
            //     {
            //         latitude: parking_latitude,
            //         longitude: parking_longitude
            //     },
            //     'q_route_zm_picture'
            // )

            const estimateData = {
                ...this.state.data.values,
                quote_route_picture_url: "",
                ESTIMATE__quote_route_picture_url: " ",
                quote_route_zoom_picture_url: survey_route_zoom_picture_url,
                ESTIMATE__quote_route_zoom_picture_url: GoogleDrive.getDownloadUrl(survey_route_zoom_picture_url),
            }
            
            estimateCommonParams["object_estimate"]["ESTIMATE__id"] = id

            Request.setProgress(60)
            {
                const latest_plotting_picture_url = this.state.data.values.latest_plotting_picture_url
                const update_timestamp = this.state.data.values.update_timestamp;
    
                const file_upload = await new Promise((resolve, reject) => {
                    let ulid = estimateData.estimate_ulid ? estimateData.estimate_ulid : estimateData.ulid; 
    
                    const url = '/api/quote/file_upload/' + ulid
                    const uploadParams = {
                        ...estimateData,
                        latest_plotting_picture_url,
                        update_timestamp,
                        latest_pdf_plotting_request_status:3,
                        blockmap_user_id: 0
                    }
    
                    Request.put(url, uploadParams, res => {
                        this.setState(prevState => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                values: {
                                    ...prevState.data.values,
                                    update_timestamp: res.Data.update_timestamp
                                }
                            }
                        }))
                        resolve(res)
                    }, err => reject(err));
                })
            }
            // const {
            //     PROJECT__send_destination_type
            // } = estimateCommonParams.object_project

            // const isMailAllowed = ((want_guide_type == "1" || want_guide_type == "0") && (PROJECT__send_destination_type == "0" || PROJECT__send_destination_type == "2"))
            //     || ((want_guide_type_subcontract == "1" || want_guide_type_subcontract == "0") && (PROJECT__send_destination_type == "1" || PROJECT__send_destination_type == "2"))

            // const {
            //     CUSTOMER_USER__customer_reminder_sms_flag_code,
            //     CUSTOMER_USER__customer_user_tel
            // } = estimateCommonParams.object_customer

            // const {
            //     CUSTOMER_USER__customer_reminder_sms_flag_code: CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
            //     CUSTOMER_USER__customer_user_tel: CUSTOMER_USER__customer_user_tel_subcontract
            // } = estimateCommonParams.object_customer_subcontract

            // const isSmsAllowed = ((PROJECT__send_destination_type == "0" || PROJECT__send_destination_type == "2") && CUSTOMER_USER__customer_reminder_sms_flag_code == "1" && CUSTOMER_USER__customer_user_tel)
            //     || ((PROJECT__send_destination_type == "1" || PROJECT__send_destination_type == "2") && CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract == "1" && CUSTOMER_USER__customer_user_tel_subcontract)


            Request.setProgress(0);
            document.body.style.overflow = "auto";

            this.props.alertModal.current.confirmCheck({
                title: "処理完了",
                messageNo: 2417,
                closeBtn: false
            }, () => {
                this.toggleModal()
                this.props.refreshCallback()
            }, false)

        } catch (err) {
            Request.setProgress(0)
            this.props.alertModal.current.showErrorModal({
                messageNo: 2476
            })
        }
    }

    bodyContent() {
        return (
            <>
                <div>
                    <Label>アップロード済区画図：</Label>
                    {
                        this.state.data.values.quote_plotting_picture_url &&
                        <a className="link" target='_blank' href={GoogleDrive.getDownloadUrl(this.state.data.values.quote_plotting_picture_url, `区画図_${moment().format("YYYYMMDDHHmmss")}`)}>区画図確認</a>
                    }
                    <span style={{ float: "right" }}>
                        <ImageControl
                            gcs_path="q_plotting_picture"
                            uploadCallback={(croppedImageObject) => {
                                const {
                                    id,
                                } = croppedImageObject
                                this.props.validateCallBackForDialog({
                                    ...this.state.data,
                                    values: {
                                        ...this.state.data.values,
                                        quote_plotting_picture_url: id
                                    }
                                })
                            }}
                            buttonName={"ファイル選択"}
                            cropData={{
                                unit: '%',
                                width: 30,
                                aspect: (1260 / 1260),
                            }}
                        />
                    </span>
                    <p style={{ color: "red" }}>{!this.state.data.values.quote_plotting_picture_url && GetMessage(2024)}</p>
                </div>
                {/* {this.state.plotting_number_flag == true ? (<InputText
                    label='契約区画番号'
                    labelOn={true}
                    name='ESTIMATE__quote_plotting_number'
                    validateCallback={this.props.validateCallBackForDialog}
                    rootData={this.state.data}
                    validateType="regist"
                    disabled={true}
                />):""} */}
                <div id="googlemap" style={{display:"none"}}>
                </div>
            </>
        );
    }
}

export default RegistDialog;